export enum TrackingRawEventName {
  WebviewViewed = "WebviewViewed",
  SearchSuggestionTapped = "SearchSuggestionTapped",
  PageOpened = "PageOpened",
}
